import {
  isSlowMohs,
  isSlowMohsDebulk,
  isSlowMohsMargin,
  isSlowMohsWhole,
} from "./conditions";
import { GrossingSegment } from "./segments";
import { softenedAndDecalcifiedSegments } from "./segmentsCommon";

// An alternate set of GrossingSegments for use with the Slow Mohs Protocol.

export const grossingSegments: GrossingSegment[] = [
  {
    content:
      'The specimen received in formalin labeled with patient name and "{source}" is [slowMohsAn] {slow_mohs_shape}[slowMohsExcision] of skin',
  },
  {
    content:
      " measuring {measurement_w} cm x {measurement_l} cm x {measurement_h} cm",
    condition: (s) => s.modifierSelections.slowMohsMeasurements,
  },
  {
    content: ".",
  },
  {
    content:
      " There is an orienting {slow_mohs_orientation} at the {slow_mohs_orienting_margin} o'clock margin",
    condition: (s) =>
      isSlowMohs(s) && s.modifierSelections.slowMohsOrientingMark,
  },
  {
    content:
      " and an orienting {slow_mohs_orientation} at the {slow_mohs_orienting_margin} o'clock margin",
    condition: (s) =>
      isSlowMohsDebulk(s) &&
      s.modifierSelections.slowMohsOrientingMark &&
      s.modifierSelections.slowMohsAdditionalOrientingMark,
  },
  {
    content: ".",
    condition: (s) =>
      isSlowMohs(s) && s.modifierSelections.slowMohsOrientingMark,
  },
  {
    content:
      " The debulk specimen is excised, {grossed} from {slow_mohs_margin} to {slow_mohs_margin} and submitted as {cassette_count}. Peripheral margins are submitted in a clockwise manner starting at 12:00.",
    condition: isSlowMohsWhole,
  },
  {
    content:
      " The {slow_mohs_margin_number} {slow_mohs_margin_label} is inked {inked_color} at the {slow_mohs_orienting_margin} o'clock margin",
    condition: isSlowMohsMargin,
  },
  {
    content:
      ", {inked_color} at the {slow_mohs_orienting_margin} o'clock margin,",
    condition: (s) =>
      isSlowMohsMargin(s) &&
      s.tokenSelections.slow_mohs_margin_label?.value === "strip",
  },
  {
    content: " and",
    condition: isSlowMohsMargin,
  },
  {
    content:
      " The debulk is {grossed} from {slow_mohs_margin} to {slow_mohs_margin} and",
    condition: isSlowMohsDebulk,
  },
  {
    content: " submitted as {cassette_count}.",
    condition: (s) => isSlowMohsDebulk(s) || isSlowMohsMargin(s),
  },
  ...softenedAndDecalcifiedSegments,
];

export default grossingSegments;
